import React from "react";
import { map, uniqueId } from "lodash";
import { IllustrationProps } from ".";

const PATHS = {
  landscape:
    "M20.375 28L28.5 44l8.125-8L48 58H9l11.375-30zM42.5 17a3.5 3.5 0 110 7 3.5 3.5 0 010-7z",
  balloon:
    "M29,10a19.18,19.18,0,0,1,15.71,8.34A18.83,18.83,0,0,1,48,28c0,.33,0,.66,0,1a19,19,0,0,1-4.24,12A19.26,19.26,0,0,1,37,46.22,18.76,18.76,0,0,1,23,47,19.09,19.09,0,0,1,10,29a19.45,19.45,0,0,1,.15-2.3,18.79,18.79,0,0,1,2.48-7.29,19.07,19.07,0,0,1,10.52-8.48A18.86,18.86,0,0,1,29,10Zm0,1.83a16.91,16.91,0,0,0-4.91.73h0l.05.09-3.91,6.76H14.77A17,17,0,0,0,12,26.7h1.9l3.9,6.77-3,5.19a17.23,17.23,0,0,0,9.08,6.73h0l2.4-4.15H34.1l2,3.39a17.22,17.22,0,0,0,6.69-5.41h0l-2.57-4.45L44.09,28h2a17.11,17.11,0,0,0-2.89-8.59H36.28l-3.9-6.76.24-.43A17.3,17.3,0,0,0,29,11.83ZM33,22l4,7.5L33,37H25l-4-7.5L25,22Z",
};

const uid = uniqueId();

export default ({ colors }: IllustrationProps) => (
  <svg width="100%" height="100%" viewBox="0 0 310 120">
    <defs>
      <rect id={"thumbnail" + uid} x={0} y={0} width={58} height={58} rx={3} />

      {map(PATHS, (path, id) => (
        <g id={id + uid} key={id}>
          <use fill={colors.content.tertiary} xlinkHref={"#thumbnail" + uid} />
          <path d={path} fill={colors.content.primary} />
        </g>
      ))}
    </defs>
    <g>
      <use x="0" y="0" xlinkHref={"#landscape" + uid} />
      <use x="63" y="0" xlinkHref={"#landscape" + uid} />
      <use x="126" y="0" xlinkHref={"#landscape" + uid} />
      <use x="189" y="0" xlinkHref={"#landscape" + uid} />
      <use x="252" y="0" xlinkHref={"#landscape" + uid} />

      <use x="0" y="63" xlinkHref={"#balloon" + uid} />
      <use x="63" y="63" xlinkHref={"#balloon" + uid} />
      <use x="126" y="63" xlinkHref={"#balloon" + uid} />
      <use x="189" y="63" xlinkHref={"#balloon" + uid} />
      <use x="252" y="63" xlinkHref={"#balloon" + uid} />
    </g>
  </svg>
);
